import React, { useState } from 'react'
import { Dialog, DialogActions, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone'

interface Props {
  open: boolean
  setOpen: (op: boolean) => void
  identifier: string
  data: string
}

const CopyCodeId: React.FC<any> = ({ open, setOpen, identifier, data }: Props) => {
  const [identifierCopiado, setIdentifierCopiado] = useState<boolean>(false)

  const handleClose = () => {
    setOpen(false)
    setIdentifierCopiado(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          overflowX: 'hidden',
        }
      }}
    >
      <Box sx={{ margin: '30px 30px 10px 30px', display: 'flex', flexDirection: 'row', gap: '10px' }}>
        <Typography variant="h6">
          {`El ${identifier} es `}
          <strong>{data}</strong>
        </Typography>
        <ContentCopyTwoToneIcon
          sx={{ cursor: 'pointer', marginTop: '6px' }}
          onClick={() => {
            setIdentifierCopiado(true)
            navigator.clipboard.writeText(data)
          }}
          color={identifierCopiado ? 'primary' : 'action'}
          titleAccess="Copiar link"
        />
      </Box>
      <DialogActions>
        <IconButton
          edge="end"
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '16px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  )
}

export default CopyCodeId
